import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const PBI_ENDPOINTS = {
  base: `${BASE_URL}api/pbi/`,
  detail: (id) => `${PBI_ENDPOINTS.base}${id}/`,
};

class Pbi {
  async removePbi(id) {
    return await request({
      url: PBI_ENDPOINTS.detail(id),
      method: "DELETE",
    });
  }
}

export const PbiService = new Pbi();
